<h1 mat-dialog-title>{{ trans.DialogMessage | translate}}</h1>

<div  mat-dialog-content>
  <p>{{ message }}</p>
</div>

<div mat-dialog-actions>
    <button class="mat-btn-custom " mat-button (click)="closeDialog()" cdkFocusInitial>  {{ trans.No | translate }} </button>
    <button class="mat-btn-custom mat-btn-theme" mat-button (click)="confirmNavigation()" > {{ trans.Yes | translate }}</button>
</div>
